import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "ratio ratio-16x9 loading-background" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "avatar ratio ratio-1x1 w-50 mx-auto text-center align-items-center" }
const _hoisted_8 = { class: "profile-picture" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "row pb-2 text-center" }
const _hoisted_11 = {
  key: 0,
  class: "col-12 d-flex flex-column justify-content-center align-items-center mb-2"
}
const _hoisted_12 = { class: "form-floating" }
const _hoisted_13 = { class: "my-2 d-flex justify-content-between" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "fas fa-spinner fa-spin ms-1"
}
const _hoisted_17 = {
  key: 1,
  class: "col-12 d-flex justify-content-center align-items-end mb-2"
}
const _hoisted_18 = {
  key: 0,
  class: "fas fa-fw fa-xs"
}
const _hoisted_19 = { class: "mb-0 text-dark text-break" }
const _hoisted_20 = { class: "col-12 mb-0" }
const _hoisted_21 = { class: "text-secondary mb-0" }
const _hoisted_22 = {
  key: 0,
  class: "col-12 text-muted small"
}
const _hoisted_23 = {
  key: 1,
  class: "col-12 d-flex flex-row justify-content-center align-items-center text-muted small text-truncate"
}
const _hoisted_24 = { class: "flag-box lh-1" }
const _hoisted_25 = { class: "lh-1 country-name fw-bold ms-2" }
const _hoisted_26 = { class: "row pt-4 pb-2" }
const _hoisted_27 = { class: "col text-nowrap d-flex" }
const _hoisted_28 = { class: "mx-auto text-truncate" }
const _hoisted_29 = { class: "text-truncate" }
const _hoisted_30 = { class: "fw-bold" }
const _hoisted_31 = {
  key: 0,
  class: "text-truncate"
}
const _hoisted_32 = { class: "small" }
const _hoisted_33 = {
  key: 0,
  class: "far fa-eye-slash fa-fw fa-sm mx-1"
}
const _hoisted_34 = { class: "fw-bold" }
const _hoisted_35 = {
  key: 1,
  class: "text-truncate"
}
const _hoisted_36 = { class: "small" }
const _hoisted_37 = {
  key: 0,
  class: "far fa-eye-slash fa-fw fa-sm mx-1"
}
const _hoisted_38 = { class: "fw-bold vertical-align-middle" }
const _hoisted_39 = {
  key: 0,
  class: "me-1"
}
const _hoisted_40 = {
  key: 2,
  class: "text-truncate"
}
const _hoisted_41 = { class: "small" }
const _hoisted_42 = {
  key: 0,
  class: "far fa-eye-slash fa-fw fa-sm mx-1"
}
const _hoisted_43 = { class: "fw-bold vertical-align-middle" }
const _hoisted_44 = {
  key: 0,
  class: "me-1"
}
const _hoisted_45 = {
  key: 3,
  class: "text-truncate"
}
const _hoisted_46 = { class: "small" }
const _hoisted_47 = {
  key: 0,
  class: "far fa-eye-slash fa-fw fa-sm mx-1"
}
const _hoisted_48 = { class: "fw-bold vertical-align-middle" }
const _hoisted_49 = {
  key: 0,
  class: "me-1"
}
const _hoisted_50 = {
  key: 4,
  class: "text-truncate"
}
const _hoisted_51 = { class: "small" }
const _hoisted_52 = {
  key: 0,
  class: "far fa-eye-slash fa-fw fa-sm mx-1"
}
const _hoisted_53 = ["href"]
const _hoisted_54 = {
  key: 5,
  class: "text-truncate"
}
const _hoisted_55 = { class: "small" }
const _hoisted_56 = {
  key: 0,
  class: "far fa-eye-slash fa-fw fa-sm mx-1"
}
const _hoisted_57 = ["href"]
const _hoisted_58 = {
  key: 6,
  class: "text-truncate"
}
const _hoisted_59 = { class: "small" }
const _hoisted_60 = {
  key: 0,
  class: "far fa-eye-slash fa-fw fa-sm mx-1"
}
const _hoisted_61 = ["href"]
const _hoisted_62 = { class: "text-truncate" }
const _hoisted_63 = {
  key: 7,
  class: "text-truncate"
}
const _hoisted_64 = { class: "fw-bold text-nowrap small" }
const _hoisted_65 = {
  key: 8,
  class: "text-truncate"
}
const _hoisted_66 = { class: "fw-bold small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rank_icon = _resolveComponent("rank-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.coverImage,
          class: "card-img-top",
          alt: "Cover image"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("img", {
                class: "rounded-circle border border-3 border-light w-100 gtr-avatar-bg",
                src: _ctx.userPicture
              }, null, 8, _hoisted_9)
            ]),
            (_ctx.canEdit)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openGalleryModal())),
                  class: "change-picture-overlay d-flex justify-content-center align-items-center w-100 rounded-circle border-3 border-light bg-dark p-4 text-light border border-3 border-light w-100"
                }, [...(_cache[5] || (_cache[5] = [
                  _createStaticVNode("<div class=\"\" data-v-d0db107a><div class=\"mb-1\" data-v-d0db107a><i class=\"fas fa-camera fa-2x fa-fw\" data-v-d0db107a></i></div><div class=\"lh-1 fs-4 d-xl-none\" data-v-d0db107a> Cambiar foto de perfil </div><div class=\"lh-1 d-none d-xl-flex\" data-v-d0db107a> Cambiar foto de perfil </div></div>", 1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", null, [
            (_ctx.editMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control fs-3 text-center text-dark",
                      placeholder: "Nickname",
                      id: "nickname",
                      ref: "nickname",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localNickname) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.localNickname]
                    ]),
                    _cache[6] || (_cache[6] = _createElementVNode("label", { for: "nickname" }, "Apodo / Nickname", -1))
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", {
                      disabled: _ctx.saving,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancelEdit())),
                      class: "btn btn-sm btn-outline-danger me-2"
                    }, [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("i", { class: "fas fa-ban fa-fw me-1" }, null, -1),
                      _createTextVNode("Cancelar ", -1)
                    ]))], 8, _hoisted_14),
                    _createElementVNode("button", {
                      disabled: _ctx.saving,
                      class: "btn btn-sm btn-outline-success",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.save()))
                    }, [
                      _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fas fa-save fa-fw me-1" }, null, -1)),
                      _cache[9] || (_cache[9] = _createTextVNode("Guardar ", -1)),
                      (_ctx.saving)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_15)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  (_ctx.canEdit)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_18))
                    : _createCommentVNode("", true),
                  _createElementVNode("h2", _hoisted_19, _toDisplayString(_ctx.user.nickname), 1),
                  (_ctx.canEdit)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editNickname())),
                        class: "btn p-0"
                      }, [...(_cache[10] || (_cache[10] = [
                        _createElementVNode("i", { class: "fas fa-pen fa-fw fa-xs text-muted mb-1" }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ]))
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("h5", _hoisted_21, [
              _createVNode(_component_rank_icon, {
                "icon-class": _ctx.userRank?.iconClass,
                "extra-class": "fa-fw"
              }, null, 8, ["icon-class"]),
              _createTextVNode(" " + _toDisplayString(_ctx.userRank?.name), 1)
            ])
          ]),
          (_ctx.location != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fas fa-map-marker-alt fa-fw" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.location), 1)
              ]))
            : _createCommentVNode("", true),
          (
              _ctx.user.country && _ctx.user.country != '' && _ctx.displayedCountry.alpha2Code
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("span", _hoisted_24, [
                  _createElementVNode("span", {
                    class: _normalizeClass('lh-1 d-block flag ' + _ctx.displayedCountry.alpha2Code)
                  }, null, 2)
                ]),
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.displayedCountry.spanish), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "small" }, [
                  _createElementVNode("i", { class: "fas fa-user fa-fw" }),
                  _createTextVNode(" Usuario: ")
                ], -1)),
                _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.user.username), 1)
              ]),
              (_ctx.user.contact.email && _ctx.user.contact.email.data != '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("span", _hoisted_32, [
                      _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fas fa-envelope fa-fw" }, null, -1)),
                      (!_ctx.user.contact.email.visible)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_33))
                        : _createCommentVNode("", true),
                      _cache[14] || (_cache[14] = _createTextVNode("E-mail: ", -1))
                    ]),
                    _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.user.contact.email.data), 1)
                  ]))
                : _createCommentVNode("", true),
              (
                  _ctx.user.contact.mobile && _ctx.user.contact.mobile.data.number != ''
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createElementVNode("span", _hoisted_36, [
                      _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fas fa-mobile-alt fa-fw" }, null, -1)),
                      (!_ctx.user.contact.mobile.visible)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_37))
                        : _createCommentVNode("", true),
                      _cache[16] || (_cache[16] = _createTextVNode("Celular: ", -1))
                    ]),
                    _createElementVNode("span", _hoisted_38, [
                      (_ctx.user.contact.mobile.data.dialCode != '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.user.contact.mobile.data.dialCode), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(_ctx.user.contact.mobile.data.number), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (
                  _ctx.user.contact.whatsapp &&
                  _ctx.user.contact.whatsapp.data.number != ''
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createElementVNode("span", _hoisted_41, [
                      _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fab fa-whatsapp fa-fw" }, null, -1)),
                      (!_ctx.user.contact.whatsapp.visible)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_42))
                        : _createCommentVNode("", true),
                      _cache[18] || (_cache[18] = _createTextVNode("Whatsapp: ", -1))
                    ]),
                    _createElementVNode("span", _hoisted_43, [
                      (_ctx.user.contact.whatsapp.data.dialCode != '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.user.contact.whatsapp.data.dialCode), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(_ctx.user.contact.whatsapp.data.number), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (
                  _ctx.user.contact.telegram &&
                  _ctx.user.contact.telegram.data.number != ''
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _createElementVNode("span", _hoisted_46, [
                      _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fab fa-telegram fa-fw" }, null, -1)),
                      (!_ctx.user.contact.telegram.visible)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_47))
                        : _createCommentVNode("", true),
                      _cache[20] || (_cache[20] = _createTextVNode("Telegram: ", -1))
                    ]),
                    _createElementVNode("span", _hoisted_48, [
                      (_ctx.user.contact.telegram.data.dialCode != '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_ctx.user.contact.telegram.data.dialCode), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(_ctx.user.contact.telegram.data.number), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (
                  _ctx.user.contact.instagram && _ctx.user.contact.instagram.data != ''
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _createElementVNode("span", _hoisted_51, [
                      _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fab fa-instagram fa-fw" }, null, -1)),
                      (!_ctx.user.contact.instagram.visible)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_52))
                        : _createCommentVNode("", true),
                      _cache[22] || (_cache[22] = _createTextVNode("Instagram: ", -1))
                    ]),
                    _createElementVNode("span", null, [
                      _createElementVNode("a", {
                        class: "fw-bold link-secondary vertical-align-middle",
                        href: 
                      'https://www.instagram.com/' + _ctx.user.contact.instagram.data
                    ,
                        target: "_blank"
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.user.contact.instagram.data) + " ", 1),
                        _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fas fa-external-link-alt fa-xs fa-fw" }, null, -1))
                      ], 8, _hoisted_53)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.user.contact.tiktok && _ctx.user.contact.tiktok.data != '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    _createElementVNode("span", _hoisted_55, [
                      _cache[24] || (_cache[24] = _createElementVNode("i", { class: "fab fa-tiktok fa-fw" }, null, -1)),
                      (!_ctx.user.contact.tiktok.visible)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_56))
                        : _createCommentVNode("", true),
                      _cache[25] || (_cache[25] = _createTextVNode("Tiktok: ", -1))
                    ]),
                    _createElementVNode("span", null, [
                      _createElementVNode("a", {
                        class: "fw-bold link-secondary vertical-align-middle",
                        href: 'https://www.tiktok.com/' + _ctx.tiktokUsername,
                        target: "_blank"
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.tiktokUsername) + " ", 1),
                        _cache[26] || (_cache[26] = _createElementVNode("i", { class: "fas fa-external-link-alt fa-xs fa-fw" }, null, -1))
                      ], 8, _hoisted_57)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.user.contact.facebook && _ctx.user.contact.facebook.data != '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                    _createElementVNode("span", _hoisted_59, [
                      _cache[27] || (_cache[27] = _createElementVNode("i", { class: "fab fa-facebook fa-fw" }, null, -1)),
                      (!_ctx.user.contact.facebook.visible)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_60))
                        : _createCommentVNode("", true),
                      _cache[28] || (_cache[28] = _createTextVNode("Facebook: ", -1))
                    ]),
                    _createElementVNode("span", null, [
                      _createElementVNode("a", {
                        class: "fw-bold link-secondary vertical-align-middle",
                        href: 
                      'https://www.facebook.com/' + _ctx.user.contact.facebook.data
                    ,
                        target: "_blank"
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.user.contact.facebook.data) + " ", 1),
                        _cache[29] || (_cache[29] = _createElementVNode("i", { class: "fas fa-external-link-alt fa-xs fa-fw" }, null, -1))
                      ], 8, _hoisted_61)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_62, [
                _cache[30] || (_cache[30] = _createElementVNode("span", { class: "small" }, [
                  _createElementVNode("i", { class: "fas fa-handshake fa-fw" }),
                  _createTextVNode(" Patrocinador: ")
                ], -1)),
                _createElementVNode("span", null, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.user.enroller), 1)
                ])
              ]),
              (_ctx.user.metadata)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _cache[31] || (_cache[31] = _createElementVNode("span", { class: "small" }, [
                      _createElementVNode("i", { class: "fas fa-flag-checkered fa-fw" }),
                      _createTextVNode(" Registro: ")
                    ], -1)),
                    _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.formatDateTimezone(_ctx.user.metadata?.creationTime.getTime())), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.user.metadata)
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    _cache[32] || (_cache[32] = _createElementVNode("span", { class: "small" }, [
                      _createElementVNode("i", { class: "fas fa-sign-in-alt fa-fw" }),
                      _createTextVNode(" Última sesión: ")
                    ], -1)),
                    _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.formatDateTimezone(_ctx.user.metadata?.lastSignInTime.getTime())), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}